export function validateNumbers() {
    const _document = this._document;
    const inputs = _document.querySelectorAll(".input-number");
    const regex = /^[0-9]*$/gm;
    const errorMessage = "<span role=\"alert\" class=\"wpcf7-not-valid-tip\">The field should contains only numbers</span>";

    [...inputs].forEach(input => {
        input.addEventListener("blur", (event) => {
            if(!input.value.match(regex)) {
                input.classList.add("wpcf7-not-valid");
                input.setAttribute("aria-invalid", "true");
                if(input.nextElementSibling === null) {
                    input.insertAdjacentHTML("afterend", errorMessage);
                }
            } else {
                input.classList.remove("wpcf7-not-valid");
                input.setAttribute("aria-invalid", "false");
                if(input.nextElementSibling !== null && input.nextElementSibling.classList.contains("wpcf7-not-valid-tip")) {
                    input.nextElementSibling.remove();
                }
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/validate-numbers.js